import React from 'react';
import ReactDOM from 'react-dom';

import './Style.css';

class ListaEmpreendimentos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            sending: false,
            cityPeriod: props.cityPeriod || null,
            empreendimentos: [],
            errors: {},
        };
    }

    fetchEvaluations = async () => {
        const {
            cityPeriod,
        } = this.state;

        if (!cityPeriod?.id) {
            return;
        }

        this.setState({
            loading: true,
        });

        try {
            const response = await axios.get(`/executar-auditoria/${cityPeriod.id}`);

            this.setState({
                empreendimentos: response.data?.data || [],
                loading: false
            });

        } catch (error) {
            console.error('Erro ao executar auditoria:', error);

            this.setState({
                loading: false,
            });
        }
    };

    componentDidMount() {
        this.fetchEvaluations();
    }

    getEvaluationGroups = (empreendimento) => {
        const groups = {};

        (empreendimento.evaluations || []).forEach(
            (evaluation) => {
                const evaluationWeight = evaluation.evaluation_weigth;

                if (!evaluationWeight) {
                    return;
                }

                const weightId = evaluationWeight.id;

                if (!groups[weightId]) {
                    groups[weightId] = {
                        evaluationWeight,
                        evaluations: [],
                        conditionals: [],
                    };
                }

                groups[weightId].evaluations.push(
                    evaluation
                );

                if (evaluation.conditional) {
                    groups[weightId].conditionals.push({
                        ...evaluation.conditional,
                        evaluationId: evaluation.id,
                    });
                }
            }
        );

        return Object.values(groups);
    };

    formatConditional = (conditional) => {
        if (!conditional) {
            return '';
        }

        const {
            operator,
            compare_with,
            fixed_value,
            field,
        } = conditional;

        const parts = [];

        if (operator) {
            parts.push(operator);
        }

        if (compare_with) {
            parts.push(compare_with);
        }

        if (fixed_value !== null && fixed_value !== undefined && fixed_value !== '') {
            parts.push(`"${fixed_value}"`);
        }

        if (field) {
            parts.push(`campo: ${field}`);
        }

        return parts.join(' ');
    };

    render() {
        const {
            empreendimentos,
            cityPeriod,
            loading,
            sending,
        } = this.state;

        return (
            <div>
                <div className="lista-empreendimentos-auditados">
                    <div className="card" style={{ height: '100%' }}>
                        {loading ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i>
                            </div>
                        ) : empreendimentos.length === 0 ? (
                            <p className="title">Nenhum empreendimento inválido.</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table-stripped">
                                    <thead>
                                        <tr>
                                            <th>Empreendimento</th>
                                            <th>Erro</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {empreendimentos.map(
                                            (empreendimento) => {
                                                const evaluationGroups = this.getEvaluationGroups(empreendimento);

                                                return (
                                                    <tr key={empreendimento.id}>
                                                        <td>
                                                            <a
                                                                href={`/building/${empreendimento.building_id}/edit`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                <strong>{empreendimento.building_name}</strong>
                                                            </a>
                                                        </td>

                                                        <td>
                                                            <div className="erros-empreendimento">
                                                                {evaluationGroups.map(
                                                                    (group) => (
                                                                        <div key={group.evaluationWeight.id}>
                                                                            {group.evaluationWeight.reason} / {group.evaluationWeight.criterion}
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <a
                            href={`/atualizacao-nova/${cityPeriod.id}`}
                            role="button"
                            className='btn btn-voltar'
                        >Voltar</a>
                    </div>
                </div>
            </div>
        );
    }
}

const element = document.getElementById('app-lista-empreendimentos-auditados');

if (element) {
    const props = {
        cityPeriod: JSON.parse(element.dataset.cityPeriod || '{}'),
    };

    ReactDOM.render(<ListaEmpreendimentos {...props} />, element);
}
export default ListaEmpreendimentos;